type ModalProps = {
  title: string;
  closeAction: () => void;
  children: React.ReactNode;
  footerContent: React.ReactNode;
};

export const Modal = ({
  title,
  closeAction,
  children,
  footerContent,
}: ModalProps) => {
  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center z-10 p-20 overflow-y-auto">
        <div className="w-full h-fit bg-white rounded-sm border !border-sky-900/70">
          <header className="bg-sky-900/70 p-2 text-white font-medium flex justify-between">
            {title}
            {/* <button type="button" className="" onClick={closeAction}>
              <i className="bi bi-x-lg"></i>
            </button> */}
          </header>
          <div className="w-full px-3 py-2 h-fit">
            <div className="h-fit">{children}</div>
            <div className="w-full flex justify-center border-t pt-2 mt-2 gap-2">
              {footerContent ? (
                footerContent
              ) : (
                <button className="btn btn-success" onClick={closeAction}>
                  Close
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
